// ** Redux Imports
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

// ** Axios Imports
import API from 'api/formulas'

export const list = createAsyncThunk('appFormulas/list', async () => {
  return await API.listFormulas()
})

export const get = createAsyncThunk('appFormulas/get', async name => {
  return await API.getFormula(name)
})

export const add = createAsyncThunk('appFormulas/add', async (instance, { dispatch }) => {
  const updated = await API.createFormula(instance)
  instance = {
    ...instance,
    ...updated
  }
  await dispatch(list())
  return instance
})

export const modify = createAsyncThunk('appFormulas/modify', async (instance, { dispatch }) => {
  const updated = await API.updateFormula(instance)
  instance = {
    ...instance,
    updated
  }
  await dispatch(list())
})

export const del = createAsyncThunk('appFormulas/del', async (name, { dispatch }) => {
  await API.deleteFormula(name)
  await dispatch(list())
  return name
})

export const appFormulasSlice = createSlice({
  name: 'appFormulas',
  initialState: {
    data: [],
    selected: null
  },
  reducers: {
    setSelected: (state, { payload }) => {
      state.selected = payload
    }
  },  extraReducers: builder => {
    builder
      .addCase(list.fulfilled, (state, action) => {
        state.data = action.payload
      })
      .addCase(get.fulfilled, (state, { payload }) => {
        state.selected = payload
      })
  }
})

export default appFormulasSlice.reducer
